import React from "react";
import {Link} from "react-router-dom";
import exclamation from "@/assets/images/exclamation.svg";
import useDrmInformationSearchHooks from "@/containers/DrmInformation/useDrmInformationSearchHooks";
import {SearchResultsContainer} from "@/components/DrmInformationSearch/SearchResultsContainer";
import {SearchConditionContainer} from "@/components/DrmInformationSearch/SearchConditionContainer";
import {useDrmInformationFont} from "@/utils/useDrmInformationFont";
import {DRM_PF_URL} from "@/config";

export default function DrmInformationSearch() {
  const drmInformationHooks = useDrmInformationSearchHooks();
  useDrmInformationFont();
  return (
    <div className="uk-flex uk-flex-column uk-flex-middle">
      <div className="sub-header">
        <p className="uk-text-large uk-text-bold uk-margin-remove">
          お知らせ一覧
        </p>
      </div>
      <div className="uk-width-3-4 uk-margin-top">
        <div className="uk-flex uk-flex-middle uk-flex-between">
          <div className="uk-flex uk-flex-middle">
            <img src={exclamation} alt=""/>
            <p className="uk-text-medium uk-text-bold uk-margin-small-left">
              お知らせ一覧
            </p>
          </div>
          <a href={DRM_PF_URL}>DRM-PFポータルサイトへ</a>
        </div>
        <div className="uk-margin-top">
          <ul className="uk-tab attribute-tab">
            <li className="uk-active">
              <Link to="#">検索</Link>
            </li>
            <div className="right uk-flex">
              <p>更新日</p>
              <p className="uk-margin-small-left">{drmInformationHooks.lastModified}</p>
            </div>
          </ul>
        </div>

        <div className="uk-margin-large-bottom">
          <SearchConditionContainer drmInformationHooks={drmInformationHooks}/>
          <SearchResultsContainer drmInformationHooks={drmInformationHooks}/>
        </div>
      </div>
    </div>
  );
}
